import React from "react";
import {
  Alert,
  Box,
  Card,
  CircularProgress,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { CampaignOutlined } from "@mui/icons-material";
import PageHeader from "../../common/PageHeader";
import { GlobalContext } from "../../context/GlobalContext";

const AdsTracking = () => {
  const { hitAxios } = React.useContext(GlobalContext);
  const [enabled, setEnabled] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      const res = await hitAxios({
        path: "/api/web/get_web_public",
        post: false,
        admin: false,
        showLoading: false,
        showSnackbar: false,
      });
      if (res?.data?.success) {
        setEnabled(Number(res.data.data?.thank_you_test_mode) === 1);
      }
      setLoading(false);
    })();
  }, [hitAxios]);

  const update = async (next) => {
    setSaving(true);
    const res = await hitAxios({
      path: "/api/web/update_thank_you_test_mode",
      post: true,
      admin: true,
      obj: { enabled: next },
      showLoading: false,
    });
    if (res?.data?.success) setEnabled(next);
    setSaving(false);
  };

  return (
    <Box>
      <PageHeader
        title="Ads Tracking"
        subtitle="Manage conversion-testing controls without creating false purchase events."
        icon={CampaignOutlined}
        gradientIcon
      />

      <Card variant="outlined" sx={{ mt: 3, p: 3, borderRadius: 3 }}>
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography fontWeight={800}>Direct thank-you page test access</Typography>
              <Typography variant="body2" color="text.secondary">
                Allow the thank-you page to display without verified payment parameters.
              </Typography>
            </Box>
            {loading || saving ? (
              <CircularProgress size={24} />
            ) : (
              <FormControlLabel
                label={enabled ? "Active" : "Inactive"}
                labelPlacement="start"
                control={
                  <Switch
                    checked={enabled}
                    onChange={(event) => update(event.target.checked)}
                    color="warning"
                  />
                }
              />
            )}
          </Stack>

          <Alert severity="warning">
            Test mode fires the normal PageView only. It does not send a fake Purchase event.
            Disable it after testing.
          </Alert>

          <Typography variant="body2">
            Test URL: https://beyundai.app/checkout/thank-you
          </Typography>
        </Stack>
      </Card>
    </Box>
  );
};

export default AdsTracking;
